import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import React from 'react'
import OrganizationsSection from './OrganizationsSection'
import CalendarPromoCard from './CalendarPromoCard'

const OrganizationsPage: React.FC = () => {
  return (
    <PageContainer>
      <PageHeader>
        <HeaderContent>
          <TitleGroup>
            <PageTitle>Your Organizations</PageTitle>
            <PageSubtitle>Manage your businesses and teams</PageSubtitle>
          </TitleGroup>
        </HeaderContent>
      </PageHeader>

      <MainContent>
        <OrganizationsSection />

        <PromoWrapper>
          <CalendarPromoCard />
        </PromoWrapper>
      </MainContent>
    </PageContainer>
  )
}

export default OrganizationsPage

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`


const PageContainer = styled.div`
  min-height: calc(100vh - var(--impersonation-banner-height, 0px));
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
`

const PageHeader = styled.header`
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 32px 24px;
`

const HeaderContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TitleGroup = styled.div``

const PageTitle = styled.h1`
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px;
  letter-spacing: -0.02em;
`

const PageSubtitle = styled.p`
  font-size: 15px;
  color: #64748b;
  margin: 0;
`

const MainContent = styled.main`
  max-width: 800px;
  margin: 0 auto;
  padding: 32px 24px 48px;
  animation: ${fadeIn} 0.3s ease-out;
`

const PromoWrapper = styled.div`
  margin-top: 24px;
`
